import { render, staticRenderFns } from "./script-pack-sidebar.vue?vue&type=template&id=61632cdf&scoped=true&"
import script from "./script-pack-sidebar.js?vue&type=script&lang=js&"
export * from "./script-pack-sidebar.js?vue&type=script&lang=js&"
import style0 from "./script-pack-sidebar.scss?vue&type=style&index=0&id=61632cdf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61632cdf",
  null
  
)

component.options.__file = "script-pack-sidebar.vue"
export default component.exports